import { BlogsService } from './api/blogs.service';
import { MedicinesService } from './api/medicines.service';
import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AnimalsService } from './api/animals.service';
import { HealthRecordsService } from './api/healthRecords.service';
import { HealthRecordItemsService } from './api/healthRecordItems.service';

// import { SessionsService } from './api/sessions.service';
import { UsersService } from './api/users.service';
// import { VeterinaryClinicsControllersService } from './api/veterinaryClinicsControllers.service';
import { AuthService } from './api/auth.service';
import { DashboardsService } from './api/dashboards.service';
import { QRCodesService } from './api/qRCodes.service';
import { HotelsService } from './api/hotels.service';
import { GroomersService } from './api/groomers.service';
import { StoresService } from './api/stores.service';
import { PetInsurancesService } from './api/petInsurances.service';
import { PromotionsService } from './api/promotions.service';
import { TransportsService } from './api/transports.service';
import { WalkersService } from './api/walkers.service';
import { TrainersService } from './api/trainers.service';
import { OrganizationsService } from './api/organizations.service';
import { AnimalClubsService } from './api/animalClubs.service';
import { OthersService } from './api/others.service';
import { FilesService } from './api/files.service';
import { ManufacturersService } from './api/manufacturers.service';
import { ManagersService } from './api/managers.service';
import { ManagerPortalService } from './api/managerPortal.service';
import { SuppliersService } from './api/suppliers.service';
import { SupplierInvoicesService } from './api/supplierInvoices.service';
import { LegalDocumentsService } from './api/legalDocuments.service';
import { SystemNotificationsService } from './api/systemNotifications.service';
import { VideoTutorialsService } from './api/videoTutorials.service';
import { SerialNumberConfirmationsService } from './api/serialNumberConfirmations.service';
import { FriendsService } from './api/friends.service';
import { ForumService } from './api/forum.service';
import { VatService } from './api/vat.service';
import { ClinicPremiumBillingsService } from './api/clinicPremiumBillings.service';
import { SchedulingService } from './api/scheduling.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    AnimalsService,
    FilesService,
    HealthRecordsService,
    MedicinesService,
    HealthRecordItemsService,
    HotelsService,
    // SessionsService,
    UsersService,
    // VeterinaryClinicsControllersService,
    AuthService,
    DashboardsService,
    QRCodesService,
    GroomersService,
    StoresService,
    PetInsurancesService,
    PromotionsService,
    TransportsService,
    WalkersService,
    TrainersService,
    OrganizationsService,
    AnimalClubsService,
    OthersService,
    BlogsService,
    ManufacturersService,
    ManagersService,
    ManagerPortalService,
    SuppliersService,
    SupplierInvoicesService,
    SerialNumberConfirmationsService,
    LegalDocumentsService,
    SystemNotificationsService,
    VideoTutorialsService,
    FriendsService,
    ForumService,
    VatService,
    ClinicPremiumBillingsService,
    SchedulingService,
  ],
})
export class ApiModule {
  public static forRoot(
    configurationFactory: () => Configuration,
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient,
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.',
      );
    }
    if (!http) {
      throw new Error(
        'You need to configure HttpClient (provideHttpClient() or HttpClientModule)! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
